import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { ArrayInput, AutocompleteArrayInput, BooleanInput, Edit, FormDataConsumer, GetListParams, ReferenceArrayInput, SelectArrayInput, SelectInput, SimpleForm, SimpleFormIterator, TextInput, Toolbar, UpdateWithConfirmButton, required, useDataProvider, useNotify, useRefresh, useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { getChainId } from '../../lib';
import { isDefaultPointsFuelsReady } from '../../lib/defaultPointsFuels';
import { filterToQuery } from '../../utils';

const DefaultPointsFuels = (props) => {
  const notify = useNotify();
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const [fuels, setFuels] = useState<any[]>([]);
  const [selectsAllPlaces, setselectsAllPlaces] = useState(false);

  useEffect(() => {
    dataProvider.getList('fuels', { sort: { field: 'name', order: 'ASC' } } as GetListParams)
      .then(({ data }) => setFuels(data))
      .catch(() => notify('Erro ao buscar os combustíveis', { type: 'warning' }));
  }, []);
  const navigate = useNavigate();
  const refresh = useRefresh();

  const onSuccess = () => {
    notify('ra.notification.updated', { messageArgs: { smart_count: 1 } });
    refresh();
  };

  const onError = () => {
    notify('ra.notification.data_provider_error', { type: 'error' });
    navigate('/default-points-fuels-edit');
  };

  const ToolbarCustom = () => {
    return (
      <Toolbar>
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            const ready = isDefaultPointsFuelsReady(formData);
            return (
              <>
              <UpdateWithConfirmButton
                {...rest}
                data={formData}
                disabled={!ready}
                confirmTitle="Atualizar pontuação"
                confirmContent={formData.fuels && formData.fuels.some(grf => grf.factor > 2) ? "A pontuação parece estar muito alta. Deseja confirmar?" : "A pontuação será atualizada. Esta medida terá efeito imediato."}
              />
              {!ready && <Typography variant="caption" color="text.secondary" sx={{ ml: 2 }}>Selecione os postos e ao menos um combustível para atualizar.</Typography>}
              </>
            );
          }}
        </FormDataConsumer>
      </Toolbar>
    );
  }

  return (
    <Permission permission={PERMISSIONS.DEFAULT_POINTS_FUEL}>
      <Edit id={getChainId()} title="Atualizar pontuação" resource="default-points-fuels" mutationMode="pessimistic" mutationOptions={{ onSuccess, onError }}>
        <SimpleForm toolbar={<ToolbarCustom />}>
          <FormDataConsumer>
            {() => {
              return (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                    {!selectsAllPlaces &&
                      <ReferenceArrayInput
                        filter={{ chainId: getChainId(), type: 'station' }}
                        sort={{ field: 'name', order: 'ASC' }}
                        source='placeIds'
                        reference='places'
                        validate={required()}
                        perPage={null}
                      >
                        <AutocompleteArrayInput
                          filterToQuery={filterToQuery}
                          label='Postos'
                          optionText='name'
                          sx={{ minWidth: 320, marginRight: 12 }} 
                          noOptionsText={translate('ra.input.autocomplete.no_options_text')}
                        />
                      </ReferenceArrayInput>
                    }
                    <BooleanInput
                      source='selectsAllPlaces'
                      label='Selecionar todos os postos'
                      onChange={({ target: { checked } }) => setselectsAllPlaces(checked)}
                    />
                  </div>
                </>
              )
            }}
          </FormDataConsumer>
          <ArrayInput source='fuels' label='Pontos por combustível'>
            <SimpleFormIterator disableReordering>
              <FormDataConsumer>
                {({ formData, scopedFormData }) => {
                  if (!formData.fuels) { return <></>; }
                  const selectedFuelsIds = formData.fuels.filter(f => f).map(fuel => fuel.fuelId);

                  const availableFuels = fuels.filter(({ id }) => {
                    return !selectedFuelsIds.includes(id) || (scopedFormData ? scopedFormData.fuelId === id : false);
                  });

                  availableFuels.map((fuel) => fuel.fuelId = fuel.id);

                  return (
                    <SelectInput
                      label='Combustível'
                      style={{ minWidth: 220, marginRight: 10, marginTop: 16 }}
                      choices={availableFuels}
                      source="fuelId"
                      defaultValue={null}
                      validate={[required()]}
                    />
                  )
                }}
              </FormDataConsumer>
              <TextInput
                source='factor'
                style={{ minWidth: 150, marginTop: 2, marginRight: 10 }}
                label='Fator Pontos/Litro'
                format={value => (!value ? '0,00' : `${Number(value).toFixed(2)}`)}
                parse={value => (!value ? 0 : +value.replace(/[^\d]/g, '') / 100)}
                defaultValue={0}
                required
              />
            </SimpleFormIterator>
          </ArrayInput>
        </SimpleForm>
      </Edit>
    </Permission>
  );
}

export default DefaultPointsFuels;